import { useMemo, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import MicrophoneStream from "microphone-stream";
export const useTourSteps = (pathname, role) => {
    const currentPath = window.location.pathname;
    const isRecordingProcess = useSelector(
        (state) => state.layout.isRecordingProcess
    );
    if (currentPath !== "/createNote" && isRecordingProcess) {
        window.location.reload();
    }

    const tourSteps = useMemo(() => {
        const commonSteps = {
            "/createNote": [
                {
                    id: "root",
                    title: "Your Notes",
                    text: "Here is where you can enter, upload or record notes.<br><br>After you've created a note, you will be able to generate flashcards, tests and study summaries to help you learn!",
                    attachTo: { element: "root", on: "top" },
                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            text: "Next",
                            classes: "btn btn-sm btn-primary btn-next",
                            type: "next",
                        },
                        {
                            classes: "btn btn-sm btn-outline-primary",
                            text: "Skip",
                            type: "cancel",
                        },
                    ],
                },
                {
                    id: "enterNote",
                    title: "Describe your notes",
                    text: "Enter a title and topic to describe your notes.",
                    attachTo: { element: "#noteHeaderForm", on: "bottom" },

                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            classes: "btn btn-sm btn-primary",
                            text: "Next",
                            type: "next",
                        },
                        {
                            text: "Skip",
                            classes: "btn btn-sm btn-outline-primary btn-next",
                            type: "cancel",
                        },
                    ],
                },
                {
                    id: "manualNoteEntry",
                    title: "Enter Notes Manually",
                    text: "You can type or copy/paste your notes here or...",
                    attachTo: { element: "#manualNoteEntry", on: "top" },

                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            classes: "btn btn-sm btn-primary",
                            text: "Next",
                            type: "next",
                        },
                        {
                            text: "Skip",
                            classes: "btn btn-sm btn-outline-primary btn-next",
                            type: "cancel",
                        },
                    ],
                },
                {
                    id: "createBtnDivNote",
                    title: "Upload or Transcribe",
                    text: "...You can use these buttons to upload or record and transcribe your notes",
                    attachTo: { element: ".btnsNotesDiv", on: "bottom" },

                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            classes: "btn btn-sm btn-primary",
                            text: "Back",
                            type: "back",
                        },
                        {
                            text: "End",
                            classes: "btn btn-sm btn-outline-primary btn-next",
                            type: "cancel",
                        },
                    ],
                },
                {
                    id: "saveBtnDiv",
                    title: "Save your notes",
                    text: "Finally, save your notes and prepare for Smart-Study!",
                    attachTo: { element: "#saveBtnDiv", on: "right" },

                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            //action: () => instance.cancel(),
                            classes: "btn btn-sm btn-primary",
                            text: "Back",
                            type: "back",
                        },
                        {
                            text: "End",
                            classes: "btn btn-sm btn-outline-primary btn-next",
                            type: "cancel",
                            //action: () => instance.nex),
                        },
                    ],
                },
            ],

            "/courses": [
                {
                    id: "root",
                    title: "Welcome to Smart-Study for Instructors!",
                    text: "This tour will guide you through the use of Smart-Study.<br><br>As an educator, Smart-Study is your partner in and out of the classroom.<br><br>Your students can use the power of AI to maximize their study time and get that grade they deserve!",
                    attachTo: { element: "root", on: "top" },
                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            text: "Next",
                            classes: "btn btn-sm btn-primary btn-next",
                            type: "next",
                        },
                        {
                            classes: "btn btn-sm btn-outline-primary",
                            text: "Skip",
                            type: "cancel",
                        },
                    ],
                },
                {
                    id: "createBtnDiv",
                    title: "New Course",
                    text: "Start by creating a course, which is a container of notes and tests you share with your students.",
                    attachTo: { element: ".courceCretaeParent", on: "bottom" },

                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            classes: "btn btn-sm btn-primary",
                            text: "Next",
                            type: "next",
                        },
                        {
                            text: "End",
                            classes: "btn btn-sm btn-outline-primary btn-next",
                            type: "cancel",
                        },
                    ],
                },
                {
                    id: "courseList",
                    title: "Your Courses",
                    text: "Once you've created your course(s), they will appear in a list here...",
                    attachTo: { element: "#courseList", on: "bottom" },

                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            classes: "btn btn-sm btn-primary",
                            text: "Back",
                            type: "back",
                        },
                        {
                            text: "End",
                            classes: "btn btn-sm btn-outline-primary btn-next",
                            type: "cancel",
                        },
                    ],
                },
            ],
            "/createCourse": [
                {
                    id: "CreateCourse",
                    title: "Create a New Course",
                    text: "To create a course, add a name, description and students.  Once created, you'll be able to share the course, add notes and create tests and flashcards.",
                    attachTo: { element: "root", on: "top" },

                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            text: "End",
                            classes: "btn btn-sm btn-primary btn-next",
                            type: "cancel",
                        },
                    ],
                },
            ],
            "/courseStudents": [
                {
                    id: "share",
                    title: "Share the Course",
                    text: "After you've added students to the course, you can share the course with your students here.",
                    attachTo: { element: "#share", on: "bottom" },
                    cancelIcon: {
                        enabled: true,
                    },
                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    buttons: [
                        {
                            //action: () => instance.cancel(),
                            classes: "btn btn-sm btn-primary",
                            text: "Next",
                            type: "next",
                        },
                        {
                            text: "Skip",
                            classes: "btn btn-sm btn-outline-primary btn-next",
                            type: "cancel",
                            //action: () => instance.nex),
                        },
                    ],
                },
                {
                    id: "getLink",
                    title: "Get a shareable link",
                    text: "You can share your course via a shareable URL.  Just copy the link and paste it in your favorite communication tool (email, slack, etc.)",
                    attachTo: { element: "#getLink", on: "bottom" },
                    cancelIcon: {
                        enabled: true,
                    },
                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    buttons: [
                        {
                            //action: () => instance.cancel(),
                            classes: "btn btn-sm btn-primary",
                            text: "Next",
                            type: "next",
                        },
                        {
                            classes: "btn btn-sm btn-outline-primary",
                            text: "Skip",
                            type: "cancel",
                        },
                    ],
                },
                {
                    id: "addStudents",
                    title: "Add students",
                    text: "You can add additional students to the course here...",
                    attachTo: {
                        element: "#addStudents",
                        on: "bottom",
                    },
                    cancelIcon: {
                        enabled: true,
                    },
                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    buttons: [
                        {
                            classes: "btn btn-sm btn-primary",
                            text: "Next",
                            type: "next",
                        },
                        {
                            text: "Skip",
                            classes: "btn btn-sm btn-outline-primary btn-next",
                            type: "cancel",
                            //action: () => instance.nex),
                        },
                    ],
                },
                {
                    id: "InstructorCourseList",
                    title: "List your courses",
                    text: "Get a list of your courses, add notes and create tests here...",
                    attachTo: {
                        element: "#scrollbarId",
                        on: "left",
                    },
                    cancelIcon: {
                        enabled: true,
                    },
                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    buttons: [
                        {
                            classes: "btn btn-sm btn-primary",
                            text: "Back",
                            type: "back",
                        },
                        {
                            text: "End",
                            classes: "btn btn-sm btn-primary btn-next",
                            type: "cancel",
                            //action: () => instance.nex),
                        },
                    ],
                },
            ],
        };
        if (role === "student") {
            // Add "/home" steps for students
            commonSteps["/home"] = [
                {
                    id: "root",
                    title: "Welcome to Smart-Study!",
                    text: "This tour will guide you through the use of Smart-Study.<br><br>As a student you can use the power of AI to maximize your study time and get that grade you deserve!<br><br>As an educator, Smart-Study is your partner in and out of the classroom.",
                    attachTo: { element: "root", on: "top" },
                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            text: "Next",
                            classes: "btn btn-sm btn-primary btn-next",
                            type: "next",
                        },
                        {
                            classes: "btn btn-sm btn-outline-primary",
                            text: "Skip",
                            type: "cancel",
                        },
                    ],
                },
                {
                    id: "createBtnDivNote",
                    title: "Get Started with Notes",
                    text: "To get started, you can enter or upload your class notes or even record and instantly transcribe a course lecture.",
                    attachTo: { element: "#createBtnDivNote", on: "bottom" },

                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            classes: "btn btn-sm btn-primary",
                            text: "Next",
                            type: "next",
                        },
                        {
                            text: "Skip",
                            classes: "btn btn-sm btn-outline-primary btn-next",
                            type: "cancel",
                        },
                    ],
                },
                {
                    id: "yourNotes",
                    title: "Your Notes",
                    text: "A list of the notes you've created will appear here",
                    attachTo: { element: "#yourNotes", on: "bottom" },

                    beforeShowPromise: function () {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                                resolve();
                            }, 500);
                        });
                    },
                    classes: "custom-class-name-1 custom-class-name-2",
                    highlightClass: "highlight",
                    scrollTo: false,
                    cancelIcon: {
                        enabled: true,
                    },
                    buttons: [
                        {
                            classes: "btn btn-sm btn-primary",
                            text: "Back",
                            type: "back",
                        },
                        {
                            text: "End",
                            classes: "btn btn-sm btn-outline-primary btn-next",
                            type: "cancel",
                        },
                    ],
                },
            ];
        } else {
            // Remove "/home" steps for non-students
            delete commonSteps["/home"];
        }
        const instructorCourseSteps = [
            // Define steps for instructor in "/courses" path here
        ];

        // Include "/courses" path only if role is "instructor"
        const coursesSteps =
            role === "instructor" ? {} : { "/courses": instructorCourseSteps };

        return {
            ...commonSteps,
            ...coursesSteps,
        };
    }, [role]);

    return tourSteps.hasOwnProperty(pathname) ? tourSteps[pathname] : [];
};
